import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { customFetch } from "./custom-fetch";

export type CostType = "labour" | "materials" | "fees";

export interface BulkUpdateCatalogTypeBody {
  ids: number[];
  type: CostType;
}

export interface BulkUpdateCatalogTypeResult {
  updated: number;
}

export const bulkUpdateCatalogType = async (
  body: BulkUpdateCatalogTypeBody,
  options?: RequestInit,
): Promise<BulkUpdateCatalogTypeResult> => {
  return customFetch<BulkUpdateCatalogTypeResult>(`/api/internal-catalog/bulk-type`, {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(body),
  });
};

export const useBulkUpdateCatalogType = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    BulkUpdateCatalogTypeResult,
    TError,
    { data: BulkUpdateCatalogTypeBody },
    TContext
  >;
}): UseMutationResult<
  BulkUpdateCatalogTypeResult,
  TError,
  { data: BulkUpdateCatalogTypeBody },
  TContext
> => {
  return useMutation({
    mutationFn: ({ data }) => bulkUpdateCatalogType(data),
    ...options?.mutation,
  });
};
